import React, { useEffect, useState } from "react";
import PhoneIcon from "@material-ui/icons/Phone";
import { apiHandler } from "assets/api";
import { endpoint } from "assets/api/endpoint";
import brandTheme from "brandTheme/Theme";
import { CircularProgress, makeStyles } from "@material-ui/core";

import { useSelector } from "react-redux";
const useStyles = makeStyles(() => ({
  button: {
    backgroundColor: brandTheme.buttonColor,
    color: brandTheme.white,
    borderRadius: "10px",
    padding: "10px 15px",
    minWidth: "100px",
    textTransform:'capitalize',
    border:'inherit',
    "&:hover": {
      backgroundColor: brandTheme.buttonHoverColor,
    },
  },
  button2: {
    minWidth: "100px",
    backgroundColor: brandTheme.button2Color,
    marginLeft:'10px',
    "&:hover": {
      backgroundColor: brandTheme.buttonHoverColor,
    },
  },
  link: {
    display:'flex'
  },
}));

export default function PhoneIVR({ authToken , customerPhoneNumber,agentMobileNumber}) {
  const [alertVisible, setAlertVisible] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [showActions, setShowActions] = useState(true);
  const classes = useStyles();
    const [callInProgress, setCallInProgress] = useState(false);

  const handleClick = (e) => {
    e.preventDefault(); // 🚫 stop actual tel: call
       e.stopPropagation();
    setAlertMessage("Do you need to connect IVR?");
    setShowActions(true);
    setAlertVisible(true);
  };
  const handleYes = async (e) => {
      setCallInProgress(true)
       e.stopPropagation();
      const res = await apiHandler({
        url: endpoint.IVR_INITIATE,
        method: "POST",
        authToken: authToken,
        data: {
          agentPhoneNumber:agentMobileNumber,
          customerPhoneNumber: customerPhoneNumber,
        }
      });
      setCallInProgress(false)
      if (res?.data?.status === "SUCCESS") {
        setAlertMessage("✅ Connected to IVR");
      } else {
        setAlertMessage(res?.data?.user_description || "❌ Failed to connect IVR");
      }

    setShowActions(false);

    // Auto-close after 2s
    setTimeout(() => {
      setAlertVisible(false);
    }, 2000);
  };

  const handleNo = (e) => {
       e.stopPropagation();
    setAlertVisible(false);
  };

  return (
    <>
          {callInProgress && <CircularProgress callInProgress={callInProgress} />}
    
      <a href="tel:+911234567890" onClick={handleClick} className={classes.link}>
        <PhoneIcon />
      </a>

  {alertVisible && (
  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      background: "rgba(0,0,0,0.5)",
      zIndex: 9998
    }}
  >
    <div
      style={{
        position: "fixed",
        top: "20px", // show on top
        left: "50%",
        transform: "translateX(-50%)",
        background: "#fff",
        border: "1px solid #ccc",
        padding: "30px 24px",
        borderRadius: "8px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
        zIndex: 9999,
        minWidth: "300px",
        textAlign: "center"
      }}
    >
      <p style={{ margin: 0, fontSize: "18px", fontWeight: "700" }}>
        {alertMessage}
      </p>
      {showActions && (
        <div style={{ marginTop: "20px" }}>
          <button
            onClick={handleNo}
            style={{
              cursor: "pointer"
            }}
              className={` ${classes.button}`}

          >
            No
          </button>
          <button
            onClick={handleYes}
            style={{
              cursor: "pointer"
            }}
              className={`${classes.button2} ${classes.button}`}

          >
            Yes
          </button>
        </div>
      )}
    </div>
  </div>
)}


    </>
  );
}
